export default {

  methods: {

    set_LocalValues(){
      
      this.rawData = JSON.parse(JSON.stringify(this.DataItems))
      this.weekStyle = this.Queries.SQL1[0]
      let json = JSON.parse(JSON.stringify(this.JQueries))

      this.chart   = json.chart
      this.total   = json.total
      this.week    = json.week
      this.keys    = json.keys
      this.sundries  = json.sundries

      this.cutoff = this.Queries.SQL1[0].CUTOFF
      this.filters = json.filters ? json.filters : undefined

      this.rawData.forEach(d=> {
        // d.date = d.DATE
        if(d.WEEK =='LAST' || d.WEEK =='THIS') {
          d.name = 'Total'
          d.width = this.total.width
          d.tColor = this.total.tColor
        } else {
          d.name = d.WEEK
          d.width = this.week.width
          d.tColor = this.week.tColor
        }
        d.value = d.VALUE
      })
    },

  }
}